import { FieldInput, theme } from 'aimo-ui';
import StepWrapper from 'components/common/StepWrapper';
import Icon from 'components/icons/Icon';
import useRfidRegister from 'hooks/useRfidRegister';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { useRfidStore } from 'stores/rfidStore';
import { StyledImage, StyledWrapper } from 'styles/ContainerStyles';
import { isIos } from 'utils/deviceUtils';

export const InfoIcon = () => (
  <Icon color={theme.colors.white} name="Arrow_Right" />
);

const AddTagImage: React.FC<{ testID?: string }> = ({ testID }) => (
  <StyledImage
    source={require('assets/images/add-tag.png')}
    width={250}
    height={110}
    center
    testID={testID}
  />
);

const RegisterRfidModalContent: React.FC = () => {
  const { t } = useTranslation();
  const [chargerNumber, setChargerNumber] = useState('');
  const {
    registerRfid,
    errorMessage,
    registrationStatus,
    setRegistrationStatus,
  } = useRfidRegister();
  useEffect(() => {
    useRfidStore.getState().setCurrentTagName('');
  }, []);

  const handleOpenTagScan = () => {
    if (chargerNumber.trim()) {
      setRegistrationStatus('loading');
      useRfidStore.getState().setRfidSocketNumber(chargerNumber);
      registerRfid({
        variables: {
          input: {
            publicDisplayId: chargerNumber.trim(),
          },
        },
      });
    }
  };

  const getButtonText = () => {
    if (registrationStatus === 'loading') {
      return t('account.tagsAndCards.registerRfid.chargerInput.registering');
    }
    if (registrationStatus === 'error') {
      return t('account.tagsAndCards.registerRfid.chargerInput.retry');
    }
    return t('account.tagsAndCards.next');
  };

  const renderChargerInput = () => (
    <StepWrapper
      progress={50}
      description={t(
        'account.tagsAndCards.registerRfid.chargerInput.description'
      )}
      illustrationPadding={30}
      illustration={<AddTagImage testID="add-tag-image" />}
      primaryButton={{
        text: getButtonText(),
        disabled: !chargerNumber.trim(),
        loading: registrationStatus === 'loading',
        onPress: handleOpenTagScan,
        icon: InfoIcon,
        testID: 'next-button',
      }}>
      <StyledWrapper mb={30}>
        <FieldInput
          testID="charger-number-input"
          title={t(
            'account.tagsAndCards.registerRfid.chargerInput.chargerNumber'
          )}
          value={chargerNumber}
          onChangeText={setChargerNumber}
          placeholder={t(
            'account.tagsAndCards.registerRfid.chargerInput.placeholder'
          )}
          errorMessage={
            errorMessage
              ? t('account.tagsAndCards.registerRfid.chargerInput.error')
              : undefined
          }
          errorIcon={
            <Icon
              name="Info-Filled"
              color={theme.colors.aimoUiRed}
              size={theme.iconSizes.s}
            />
          }
          isSheet={isIos}
          disabled={registrationStatus === 'loading'}
        />
      </StyledWrapper>
    </StepWrapper>
  );

  return <View>{renderChargerInput()}</View>;
};

export default RegisterRfidModalContent;
